<template>
  <dp-draft-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-draft-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/PRCreateTemplate.vue'
  export default {
    name: 'Capsule-Draft-Create',
    data: () => {
      return {
        title: 'Request to Pay - Create Draft',
        capsule: 'draft-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'dp-draft-create': CreateTemplate
    }
  }
</script>
